/**
 * @Author:Guan
 * @date 2024-9-20
 * @description: 客户管理相关接口
 */
import request from "@/utils/request";

// 查付款账户
export function companyList(params) {
    return request({
        url: '/customer/company/list', method: 'get', headers: {
            isToken: true,
        }, params
    })
}

// 获取省/直辖市列表
export function province(params) {
    return request({
        url: '/system/province/list', method: 'get', headers: {
            isToken: true,
        }, params
    })
}

// 市：区
export function city(params) {
    return request({
        url: '/system/city/list', method: 'get', headers: {
            isToken: true,
        }, params
    })
}

// 旗县区
export function area(params) {
    return request({
        url: '/system/area/list', method: 'get', headers: {
            isToken: true,
        }, params
    })
}

// 新增客户
export function company(data) {
    return request({
        url: '/customer/company', method: 'post', headers: {
            isToken: true,
        }, data
    })
}

// 新增联系人
export function addUser(data) {
    return request({
        url: '/customer/user', method: 'post', headers: {
            isToken: true,
        }, data
    })
}

// 联系人详情
export function getInfo(id) {
    return request({
        url: '/customer/user/' + id, method: 'get', headers: {
            isToken: true,
        },
    })
}

// 修改联系人
export function editUser(data) {
    return request({
        url: '/customer/user', method: 'put', headers: {
            isToken: true,
        }, data
    })
}


// 查询客户管理-企业列表所有
export function selectCustomerCompanyListAll(params) {
    return request({
        url: '/customer/company/selectCustomerCompanyListAll', method: 'get', headers: {
            isToken: true,
        }, params
    })
}


// 查询客户管理-企业详细
export function getCompany(id) {
    return request({
        url: '/customer/company/' + id, headers: {
            isToken: true,
        }, method: 'get'
    })
}

// 联系人列表
export function getCustomerList(params) {
    return request({
        url: '/customer/user/list', headers: {
            isToken: true,
        }, method: 'get', params
    })
}










